import { Component, OnInit, Output, EventEmitter, ViewChild, ChangeDetectorRef } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { catchError, debounceTime, distinctUntilChanged, switchMap, tap } from 'rxjs/operators';
import { concat, Observable, of, Subject } from 'rxjs';
import { MiscService, VisitorService, VisitorMedicalConsultationService } from '@services/index';
import { Globals } from '@app/app.globals';

@Component({
    selector: 'app-util-visitor-parts-medical-consultation-modals-add',
    templateUrl: './add.component.html',
})
export class UtilVisitorPartsMedicalConsultationModalsAddComponent implements OnInit {
    @Output() addMedicalConsultationEvent = new EventEmitter<any>();

    isLoading = false;
    isSubmitting = false;
    modal = "#addMedicalConsultationModal";
    cud = "add";
    pickerConfig: any;
    visitorMedicalConsultation: any;
    visitorId: number;
    visitors: Observable<any[]>;
    visitorsLoading = false;
    visitorsInput = new Subject();
    addForm = this.fb.group({
        id: null,
        visitor_id: [null, Validators.required],
        date: [null, Validators.required],
        doctor: null,
        speciality: null,
        remarks: null
    });
    hasData = {
        visitorMedicalConsultation: false
    };

    @ViewChild('datePicker') datePicker;

    constructor(private cdref: ChangeDetectorRef,
                private fb: UntypedFormBuilder,
                private miscService: MiscService,
                private visitorService: VisitorService,
                private visitorMedicalConsultationService: VisitorMedicalConsultationService,
                public globals: Globals) {
        this.miscService.setPageTitle("TITLES.INFIRMARY_MEDICAL_CONSULTATIONS");
    }

    ngOnInit() {
        this.pickerConfig = JSON.parse(JSON.stringify(this.globals.pickerConfig));
        this.cdref.detectChanges();
    }

    reset() {
        this.addForm.reset();
        this.resetDate();
        this.visitorId = null;
        this.cud = "add";
    }
    
    openModal(visitorId = null, visitorMedicalConsultation = null) {
        if(this.miscService.checkEnvPermission("cudVisitorMedicalConsultation")) {
            this.isLoading = true;
            this.visitorMedicalConsultation = visitorMedicalConsultation;
            this.hasData.visitorMedicalConsultation = this.miscService.checkDataLength(this.visitorMedicalConsultation);
            this.reset();
            this.visitorId = visitorId;
            if(this.visitorId) {
                this.addForm.get('visitor_id').patchValue(visitorId);
            }
            else {
                this.loadVisitors();
            }
            if(this.hasData.visitorMedicalConsultation) {
                this.cud = "edit";
                this.addForm.patchValue(this.visitorMedicalConsultation);
                if(this.visitorMedicalConsultation.date) {
                    this.datePicker.setDate(this.visitorMedicalConsultation.date);
                }
            }
            this.isLoading = false;
            $(this.modal).modal('show');
        }
    }

    goToAddVisitorUrl() {
        $(this.modal).modal('hide');
        this.miscService.goToUrlDelay(['/visitor/add']);
    }

    loadVisitors() {
        this.visitors = concat(
            of([]),
            this.visitorsInput.pipe(
                distinctUntilChanged(),
                tap(() => this.visitorsLoading = true),
                debounceTime(500),
                switchMap(term => this.visitorService.getAll({term: term, limit: 5, filter: true}).pipe(
                    catchError(() => of([])),
                    tap(() => this.visitorsLoading = false),
                ))
            )
        );
    }

    dateChanged(evt, field) {
        if(evt) {
            let date = evt;
            this.addForm.get(field).patchValue(date);
        }
        else {
            this.resetField(field);
        }
	}

    resetDate() {
        this.datePicker.resetDateNow();
    }

    resetField(field) {
        this.addForm.get(field).reset();
    }

    submit() {
        this.isSubmitting = true;
        let data = this.addForm.value;
        if(this.cud == "add") {
            this.create(data);
        }
        else {
            this.update(data);
        }
    }

    create(data) {
        this.visitorMedicalConsultationService.create(data).subscribe(data => {
            this.isSubmitting = false;
            this.miscService.showMsg({ msg: "VISITOR_MEDICAL_CONSULTATION_CREATED", status: 'success' });
            $(this.modal).modal('hide');
            this.addMedicalConsultationEvent.emit();
        }, error => {
            this.isSubmitting = false;
            this.miscService.showMsg({ msg: "VISITOR_MEDICAL_CONSULTATION_NOT_CREATED" });
        });
    }

    update(data) {
        this.visitorMedicalConsultationService.update(data).subscribe(data => {
            this.isSubmitting = false;
            this.miscService.showMsg({ msg: "VISITOR_MEDICAL_CONSULTATION_UPDATED", status: 'success' });
            $(this.modal).modal('hide');
            this.addMedicalConsultationEvent.emit();
        }, error => {
            this.isSubmitting = false;
            this.miscService.showMsg({ msg: "VISITOR_MEDICAL_CONSULTATION_NOT_UPDATED" });
        });
    }
}
